<template>
  <div class="imgage-paster">
    <Steps
      v-if="step1"
      :title="$t('edit.sandboxs.selectImg')"
      :isShowArrow="true"
      @clickBack="onClickPreTo(-1)"
      @onClickNext="onClickNextTo(2)"
    >
      <template slot="body">
        <HListWithBtn :rightButtonTile="$t('edit.sandboxs.selectImg2')" @selectChange="onSelectChange">
          <template slot="body">
            <div class="imge-item" v-if="cloneSandtable.url">
              <img :src="cloneSandtable.url" />
            </div>
          </template>
        </HListWithBtn>
      </template>
    </Steps>
    <Steps
      v-if="step2"
      :title="$t('edit.sandboxs.addScenes')"
      :isShowArrow="true"
      :rightBtnVisible="false"
      @clickBack="onClickPreTo(1)"
    >
      <template slot="body">
        <div class="scroll-base">
          <div class="item-wrapper">
            <ImageItem
              :itemObj="value"
              v-for="(value, k) in canChooseScenes"
              :key="k"
              :selected="selectedScene"
              @click.native="selectScene(value)"
            ></ImageItem>
          </div>
        </div>
      </template>
    </Steps>

    <!-- <Steps
      v-if="step3"
      :title="$t('edit.sandboxs.editMark')"
      :isShowArrow="true"
      :isLast="true"
      displayType
      @clickBack="onClickPreTo(2)"
      @onClickFinish="onClickFinish"
    >
      <template slot="body">
        <div class="scroll-base">
          <div class="item-wrapper">
            <TPItem
              v-for="(value, k) in cloneSandtable.scenes"
              :key="k"
              :itemObj="value"
              valueKey="scene_id"
              titleKey="scene_title"
              :selectedId="currentPID"
              @click.native="onClickItem(value)"
            ></TPItem>
          </div>
        </div>
      </template>
    </Steps> -->
  </div>
</template>

<script>
import Steps from "../../Steps.vue";
import HListWithBtn from "../../HListWithBtn.vue";
import ImageItem from "../../ImageItem.vue";
// import TPItem from "../../TPItem";
import { v4 as uuidv4 } from "uuid";
import { mapGetters } from "vuex";
import sandMixin from "../../../../../mixins/sandMixin";

export default {
  components: { Steps, HListWithBtn, ImageItem },
  props: {
    defaultValue: {
      type: Object,
    },
  },
  mixins: [sandMixin],
  data() {
    return {
      allScenes: {},
      newName: "",
      renameObj: {},
      renameVisible: false,
      currentImage: {},
      selectedScene: [],
      cloneSandtable: {},
      canChooseScenes: {},
      currentPID: "",

      step1: true,
      step2: false,
      step3: false,
    };
  },
  computed: {
    ...mapGetters([
      "vrbase",
      "currentScenesId",
      "currentHlookat",
      "editSandtable",
    ]),
  },
  watch: {
    editSandtable() {
      this.cloneSandtable = this.$deepClone(this.editSandtable);
      this.handleErrorSceneTypesByMixin();
    },
    allScenes(){
      this.setCanChooseScenes();
    },
  },
  created() {
    this.cloneSandtable = this.$deepClone(this.editSandtable);
    this.handleErrorSceneTypesByMixin();
    this.allScenes = this.vrbase.scenes; // 全部場景數據
    this.setCanChooseScenes();
  },
  methods: {
    onClickPreTo(value) {
      if (value === -1) {
        this.$emit("onClickBack");
      } else if (value === 1) {
        this.step1 = true;
        this.step2 = false;
        this.step3 = false;
      } else if (value === 2) {
        this.step1 = false;
        this.step2 = true;
        this.step3 = false;
      }
    },
    onClickNextTo(value) {
      if (value === 2) {
        if (!this.cloneSandtable.url) {
          this.$message.error(this.$t('edit.sandboxs.selectImg'));
          return;
        }
        this.step1 = false;
        this.step2 = true;
        this.step3 = false;
      } else if (value === 3) {
        if (this.selectedScene.length === 0) {
          this.$message.error(this.$t('edit.editMessage.sceneConfirm'));
          return;
        }
        this.step1 = false;
        this.step2 = false;
        this.step3 = true;
      }
    },

    onClickFinish() {
      this.$set(this.cloneSandtable.scenes, this.selectedScene[0].scene_id, {
        rotate: 0,
        hlookat: this.currentHlookat,
        top: "50%",
        left: "50%",
        kr_top: "50%",
        kr_left: "50%",
        scene_title: this.selectedScene[0].scene_title,
        scene_id: this.selectedScene[0].scene_id,
      });
      this.updateSandtable();
      this.setCanChooseScenes();
      this.$store.dispatch("loadScene", this.selectedScene[0].scene_id);
      this.$emit("onClickBack");
    },
    
    
    onSelectChange(value) {
      // 判斷圖片尺寸必須為480X480
      let img = new Image();
      img.src = value.url;
      img.onload = () => {
        //if (img.width >= 480 && img.height >= 480) {
          this.cloneSandtable.url = value.url;
          this.updateSandtable();
        //} else {
        //  this.$message.error(this.$t('edit.sandboxs.sizeAlert'));
        //}
      };
      img.οnerrοr = function () {
        this.$message.error(this.$t('edit.editMessage.imgeError'));
      };
    },
    onBackPre() {
      this.step1 = true;
      this.step2 = false;
    },
    // onClickFinish() {
    //   let viewAt = getSceneViewAt();
    //   this.currentPaster.ath = viewAt.hlookat;
    //   this.currentPaster.atv = viewAt.vlookat;
    //   this.$emit("saveDataToStore", {
    //     key: this.currentPaster.paster_id,
    //     data: this.currentPaster,
    //   });
    // },


    //點擊選中cell
    onClickItem(item) {
      this.currentPID = item.scene_id
      this.$store.dispatch("loadScene", item.scene_id);
      console.log(item);
    },
    selectScene(item) {
      this.selectedScene = [item];
      this.onClickFinish() // 選擇場景後，就要添加到沙盤上去
    },
    setCanChooseScenes() {
      let canChooseScenes = {};
      Object.keys(this.allScenes).forEach((key) => {
        if (!this.cloneSandtable.scenes[key]) {
          // this.$set(canChooseScenes, key, this.allScenes[key]);
          canChooseScenes[key] = this.allScenes[key];
        }
      });
      this.canChooseScenes = canChooseScenes;
    },
    updateSandtable() {
      // 更新cloneSandtable到store
      this.$store.commit("SET_EDIT_SANDTABLE", this.cloneSandtable);
    },
  },
};
</script>

<style lang="less" scoped>
.imgage-paster {
  /*padding: 5px 10px;*/
  .imge-item {
    width: 47px;
    height: 47px;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}
</style>